import React, { Component } from 'react';
import {
	Link
} from 'react-router-dom';
import Preloader from '../img/preloader.gif';
import CustomSelect from './elements/CustomSelect';
import Api from '../config/Api';

class PatientMapProgress extends Component {
	constructor(props) {
		super(props);
		this.state = {
			token: (localStorage.token ? localStorage.token : sessionStorage.token),
			fileID: this.props.match.params.id,
            fileHeaders: {},
            fileContent: {},
            rawColumns: {},
            selects: {},
            contentUploaded: false,
            loadingContents: false,
            autoMap: false
		}
	}

	componentWillMount() {
        var self = this;
		Api.getFileContents(JSON.stringify({ token: this.state.token, fileID: this.state.fileID }), function(response) {
            self.setState({
                fileHeaders: response.headers,
                fileContent: response.content,
                rawColumns: response.rawColumns
            }, function() {
                self.setState({
                    ready: true
                });
            });
        });
	}

    eachHeader = (res, i) => {
        var id = res + '_____' + i;
        return(
            <div key={i}>
                <div className="map anim1 br5" style={{backgroundColor: (i % 2 === 0 ? '#FAFAFA' : '#FFFFFF')}}>
                    <div className="row mapRow">
                        <div className="rt" style={{width: '30%', float: 'left'}}>{res}</div>
                        <div className="rt" style={{width: '30%', float: 'left'}}>{this.state.fileContent[0][res]}&nbsp;</div>
                        <div className="rt" style={{width: '40%', float: 'left', position: 'relative'}}>
                            <CustomSelect id={id} autoMap={this.state.autoMap} selectedColumns={this.state.selects} availableColumns={this.state.rawColumns} fileHeaders={this.state.fileHeaders} onChange={this.onChange} endAutoMap={this.endAutoMap} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    onChange = (id, opt) => {
        var selects = this.state.selects;
        selects[id] = opt;
        this.setState({
            selects: selects
        });
    }

    saveFileContent = () => {
        var self = this;
        if(Object.keys(this.state.selects).length < this.state.fileHeaders.length) {
            alert("You have to map every column of your CSV file.");
        } else {
            this.setState({
                loadingContents: true
            }, function() {
                Api.uploadFileContents(JSON.stringify({ token: this.state.token, headers: this.state.selects, fileID: this.state.fileID }), function(response) {
                    self.setState({
                        contentUploaded: true,
                        newPatients: response.newPatients,
                        updatedPatients: response.updatedPatients
                    });
                });
            });
        }
    }

    autoMap = () => {
        if(this.state.autoMap) {
            return false;
        } else {
            this.setState({
                autoMap: true
            });
        }
    }

    endAutoMap = () => {
        this.setState({
            autoMap: false
        });
    }

    render() {
    	return(
    		<div className="blockCtr patients br10 sh1">
    			<div className="blockHeader br10Top">
    				<Link to="/files" className="backBtn br10TopLeft"><span className="fas fa-chevron-left"></span></Link>
    				<h3>Progress File Map</h3>
    			</div>
    			<div className="blockInfo" style={{ display: (this.state.loadingContents ? 'none' : 'block') }}>
                    <div className="table" style={{ marginTop: 10 }}>
                        {this.state.ready ? '' : <img src={Preloader} alt="Fresenius Preloader" className="preloader" style={{display: 'block', maxHeight: 'auto'}} />}
                        <div className="row titleRow mobileHide" style={{ display: (this.state.ready ? 'block' : 'none') }}>
                            <div style={{width: '30%', float: 'left'}}>CSV Column</div>
                            <div style={{width: '30%', float: 'left'}}>Value From First Row</div>
                            <div style={{width: '40%', float: 'left'}}>Database Column <button className="tableHeaderLink" onClick={this.autoMap}>{this.state.autoMap ? 'Loading...' : 'Perform auto-map'}</button></div>
                        </div>
                        {this.state.ready ? this.state.fileHeaders.map(this.eachHeader) : null}
                    </div>
                    <div className="row stepConfig" style={{paddingTop: 20}}>
                        <div className="col-12 ar">
                            <button className="goBtn btn br5 anim1" onClick={this.saveFileContent} style={{display: 'inline-block'}}>Save content</button>
                        </div>
                    </div>
    			</div>
                <div className="blockInfo" style={{ display: (this.state.loadingContents ? 'block' : 'none') }}>
                    {this.state.contentUploaded ? '' : <img src={Preloader} alt="Fresenius Preloader" className="preloader" style={{display: 'block', maxHeight: 'auto'}} />}
                    <div style={{ display: (this.state.contentUploaded ? 'block' : 'none') }}>
                        The content of your file has been uploaded correctly.<br /><br />
                        {this.state.contentUploaded ? <p><strong>{this.state.updatedPatients}</strong> patients have been updated and <strong>{this.state.newPatients}</strong> patients have been added.</p> : null}
                        <div className="row stepConfig" style={{paddingTop: 20}}>
                            <div className="col-12 ar">
                                <Link className="goBtn btn br5 anim1" to="/files" style={{display: 'inline-block'}}>Go to Files</Link>
                            </div>
                        </div>
                    </div>
                </div>
    		</div>
    	);
    }
}

export default PatientMapProgress;


// WEBPACK FOOTER //
// ./src/components/FilesImportMap.js